import partFitsLogo from "../../assets/dashboard/partfits-logo-new-palette.png";
import "./LandingPage.css";

const LandingPage = () => (
  <main className="pf-public-landing" aria-labelledby="pf-public-heading">
    <div className="pf-public-landing__content">
      <img className="pf-public-landing__logo" src={partFitsLogo} alt="PartFits" />
      <h1 id="pf-public-heading">Help shoppers find the parts that fit.</h1>
      <p className="pf-public-landing__intro">
        PartFits gives Shopify merchants one place to manage vehicle compatibility,
        connect products to fitment data, and power a clearer storefront search experience.
      </p>
    </div>
  </main>
);

export default LandingPage;
